import React from 'react'
import Inner from '../component/Innerbanner' // Assuming Innerbanner is in this location

// A helper component to create styled sections
const PolicySection = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-2xl font-bold text-gray-900 mb-4">{title}</h2>
    <div className="space-y-4 text-gray-500">
      {children}
    </div>
  </div>
);

// A helper component for list items
const ListItem = ({ children }) => (
  <li className="ml-5 list-disc">{children}</li>
);

function Return() {
  return (
    <div className="font-custom">
      <Inner name="Money Back Guarantee" title="Home . RETURNS" />

      {/* --- Guarantee and Return Policy Content --- */}
      <div className="bg-white py-16 sm:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

          <PolicySection title="Our Commitment: Your Satisfaction Guarantee">
            <p>
              Your satisfaction means everything to us! We're proud to offer the **highest quality customized apparel** and the fastest turn-around time in the industry.
            </p>
            <p className="font-semibold text-lg text-teal-600">
              Please let us know if you are not completely satisfied with your order so that we can promptly fix the problem at no cost to you.
            </p>
          </PolicySection>
          
          <hr className="border-t-2 border-teal-200 my-8" />

          <PolicySection title="When You Are Eligible for a Reprint or Refund">
            <p>
              Due to the custom nature of our products, our guarantee covers specific types of issues related to our production or the product itself.
            </p>
            <p>
              If your custom apparel is found to be defective due to our error, **we will offer you a reprint or a full refund with no hassles.** This specifically covers orders that are:
            </p>
            <ul className="list-disc ml-5 space-y-2">
              <ListItem>
                **Misprinted:** The design is incorrect, off-center, or does not match the final approved proof.
              </ListItem>
              <ListItem>
                **Flawed:** The garment itself has a defect (e.g., hole, tear, stitching error) before customization.
              </ListItem>
              <ListItem>
                **Damaged:** The order was damaged in transit or upon arrival.
              </ListItem>
            </ul>
          </PolicySection>
          
          <hr className="border-t-2 border-teal-200 my-8" />

          <PolicySection title="Timeframe and Process">
            <p>
              To initiate a claim under our Money Back Guarantee, you must contact us within **30 days of receiving your order.**
            </p>
            <p>
              Please provide your order number and a clear description of the issue, ideally including photographs of the defective item(s).
            </p>
            <div className="bg-teal-50 border-l-4 border-teal-500 p-4 text-sm">
                <p className="font-bold text-teal-800">How to Contact Us</p>
                <p className='text-teal-700'>
                    Call us at **1-866-440-8237** or email us at **[Your Support Email Address]** to start the process.
                </p>
            </div>
          </PolicySection>

          <PolicySection title="What Is Not Covered (Important Exclusions)">
            <p>
              We cannot offer refunds or reprints for issues related to customer error, including:
            </p>
            <ul className="list-disc ml-5 space-y-2">
              <ListItem>
                **Incorrect Sizing Ordered:** We provide detailed sizing charts. We cannot replace items ordered in the wrong size by the customer.
              </ListItem>
              <ListItem>
                **Customer Dislike of Product/Color:** We cannot accept returns if you simply do not like the garment type, color, or style you chose after receiving it.
              </ListItem>
              <ListItem>
                **Incorrect Art/Spelling Approved:** Issues in the final design that were approved by you on the proof are not covered. Please review your proofs carefully!
              </ListItem>
            </ul>
          </PolicySection>
        </div>
      </div>
    </div>
  )
}

export default Return